import PageContent from "../PageContent";

import WorkspaceTable from "./components/table/WorkspaceTable";

const WorkspaceListView = () => {
  return (
    <PageContent appSidebar={true} title="Dine workspaces">
      <div className="h-[calc(100vh-3rem)] p-4 xl:px-8">
        <WorkspaceTable />
      </div>
    </PageContent>
  );
};

export default WorkspaceListView;
